module.exports = __webpack_public_path__ + "static/media/party-hat.20ad1b3d.gif";